import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api.js";
import { Icon, TgHeader } from "../components/ui/index.js";

interface QrResponse {
  payload: string;
  token: string;
  date: string;
  dataUrl: string;
  expiresAt: string;
  hasReadyPickup: boolean;
  readyPickupCount: number;
}

export function MyQrScreen() {
  const nav = useNavigate();
  const { data: qr, isLoading } = useQuery({
    queryKey: ["me", "qr"],
    queryFn: () => api<QrResponse>("/me/qr"),
    staleTime: 60_000,
  });

  function handleShare() {
    if (!qr) return;
    const tg = (window as any).Telegram?.WebApp;
    const text = `Мой код Mark & Post: ${qr.payload}`;
    if (tg?.openTelegramLink) {
      tg.openTelegramLink(
        `https://t.me/share/url?url=${encodeURIComponent(text)}`
      );
    } else if (navigator.share) {
      navigator.share({ text }).catch(() => {});
    }
  }

  return (
    <div className="app-shell">
      <TgHeader title="Мой QR" onBack={() => nav(-1)} />
      <div
        className="screen pad"
        style={{
          paddingTop: 24,
          paddingBottom: 32,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 18,
        }}
      >
        <div className="pr-myqr-eyebrow">
          <Icon name="stamp" size={12} />
          Mark & Post · персональный код
        </div>

        <div className="pr-myqr-frame-wrap">
          <div className="pr-myqr-frame">
            {qr?.dataUrl ? (
              <img src={qr.dataUrl} alt="Ваш QR" width={240} height={240} />
            ) : (
              <div style={{ width: 240, height: 240, display: "grid", placeItems: "center" }}>
                {isLoading ? "…" : ""}
              </div>
            )}
          </div>
        </div>

        <h2
          style={{
            margin: "4px 0 0",
            fontSize: 19,
            fontFamily: "var(--mnp-font-display)",
            fontWeight: 700,
            color: "var(--mnp-fg-1)",
          }}
        >
          Покажите оператору в ПВЗ
        </h2>

        <div className="pr-myqr-tip">
          <Icon name="clock" size={12} color="var(--mnp-fg-3)" />
          Обновляется ежедневно в полночь по Тбилиси
        </div>

        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleShare}
          style={{ marginTop: 2, display: "inline-flex", alignItems: "center", gap: 8 }}
        >
          <Icon name="send" size={14} />
          Поделиться в Telegram
        </button>
      </div>
    </div>
  );
}
